import { CHART_KEYS } from "./constants";
import { COLORS } from "../../theme/colors";

export const powerRevenueLegends = [
  {
    key: CHART_KEYS.trading,
    text: "Trading",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.battery,
    text: "Battery",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.ev,
    text: "EV",
    value: 0,
    percentage: 0,
  },
];

export const powerRevenueBars = [
  {
    dataKey: "trading",
    fill: COLORS.purple,
  },
  {
    dataKey: "battery",
    fill: "#4F31CF",
  },
  {
    dataKey: "ev",
    fill: COLORS.cian,
  },
];

export const emissionReductionLegends = [
  {
    key: CHART_KEYS.consumption,
    text: "Consumption",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.target,
    text: "Target",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.allowance,
    text: "Allowance",
    value: 0,
    percentage: 0,
  },
];

export const unrealizedPowerRevenueLegends = [
  {
    key: CHART_KEYS.power_revenue,
    text: "Power revenues",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.unrealized_trading,
    text: "Unrealized trading",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.unrealized_power_asset,
    text: "Unrealized pwr assets",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.total_unrealized,
    text: "Total unrealized",
    value: 0,
    percentage: 0,
  },
];

export const noiPowerRevenueLegends = [
  {
    key: CHART_KEYS.trading,
    text: "Trading",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.battery,
    text: "Battery",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.ev,
    text: "EV",
    value: 0,
    percentage: 0,
  },
  {
    key: CHART_KEYS.noi_with_power_revenue,
    text: "NOI with power rev",
    value: 0,
    percentage: 0,
  },
];

export const noiPowerRevenueBars = [
  {
    dataKey: "trading",
    fill: COLORS.purple,
  },
  {
    dataKey: "battery",
    fill: "#4F31CF",
  },
  {
    dataKey: "ev",
    fill: COLORS.cian,
  },
];
